<template>
  <BaseListCard
    title="Partnership Grants"
    :parentId="instrumentId"
    :parentTitle="'Instrument'"
    :options="{}"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :entitySort="entitySort"
    :deleteEntity="deleteEntity"
    :emptyEntity="emptyEntity"
    ref="baseCard"
    >
    <template v-slot:addForm="{ newEntity, options, stopAdding }">
      <PartnershipGrantForm
         :partnershipGrant="newEntity"
         :existingPartnershipGrant="newEntity"
         @closeForm="stopAdding">
      </PartnershipGrantForm>
    </template>
    <template v-slot:editForm="{  entity, options, existingEntity, stopEditing }">
      <PartnershipGrantForm
        :partnershipGrant="entity"
        :existingPartnershipGrant="existingEntity"
        @closeForm="stopEditing">
      </PartnershipGrantForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row">
        <div class="col-md-3">
          <div class="list-header">
            Grant Program
          </div>
          <div class="list-details">
            {{getGrantProgramName(entity.grantProgramId)}}
          </div>
        </div>
        <div class="col-md-3">
          <div class="list-header">
            Grantor
          </div>
          <div class="list-details">
            {{ entity.grantor | contactName }}
          </div>
        </div>
        <div class="col-md-3">
          <div class="list-header">
            Grantee
          </div>
          <div class="list-details">
            {{ entity.grantee | contactName }}
          </div>
        </div>
        <div class="col-md-3">
          <div class="list-header">
            Grant Award Amount
          </div>
          <div class="list-details">
            {{entity.awardAmount | moneyFormat}}
          </div>
        </div>
      </div>
      <hr>
      <div class="list-header">
        Grant Notes
      </div>
      <div class="list-details notes-field">{{entity.notes}}</div>
    </template>
  </BaseListCard>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import BaseListCard from '../common/BaseListCard.vue';
import CollapseParent from '@/mixins/CollapseParent';
import PartnershipGrantForm from './PartnershipGrantForm.vue';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'PartnershipGrantCard',
  props: [
    'instrumentId',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    PartnershipGrantForm,
  },
  computed: {
    ...mapState(EntityModules.PARTNERSHIP_GRANT.namespace, {
      entities: state => state.entities,
      entitiesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.GRANT_PROGRAMS.namespace, {
      getGrantProgramName: 'getName',
      grantProgramOptions: 'getActiveOptions',
    }),
  },
  created() {
    this.$store.dispatch(`${LookupModules.GRANT_PROGRAMS.namespace}/fetchOptions`,
      LookupModules.GRANT_PROGRAMS.url);
  },
  methods: {
    entitySort(a, b) {
      return (this.getGrantProgramName(a.grantProgramId)
        .localeCompare(this.getGrantProgramName(b.grantProgramId)));
    },
    emptyEntity(instrumentId) {
      return {
        instrumentId,
        grantProgramId: '',
        grantor: {},
        grantorId: '',
        grantee: {},
        granteeId: '',
        notes: null,
        awardAmount: 0.0,
      };
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${EntityModules.PARTNERSHIP_GRANT.namespace}/deleteEntity`, {
          entityType: EntityModules.PARTNERSHIP_GRANT.namespace,
          entity,
        },
      );
    },
  },
};
</script>
